import React from "react";
import './Pagination.scss';

export const Pagination = (props) => {
  const { 
    total, 
    totalPages, 
    currentPage, 
    results,
    prevClick,
    pageClick,
    nextClick
  } = props

  const finalPageResult = currentPage * results;
  const numberOfResults = `${((currentPage - 1) * results) + 1} - ${finalPageResult < total ? finalPageResult : finalPageResult - (finalPageResult - total)}`;

  const pageRange = (rangeCurrent, rangeTotal) => {
    let range = [];
    let maximumRange = rangeTotal - 6;

    if ( totalPages < 7 ) {
      for (let i = 0; i < totalPages; i++) {
        if (rangeCurrent <= totalPages) {
          range.push(rangeCurrent++);
        }
      }
    } 
    else if (rangeCurrent > 3 && rangeCurrent >= maximumRange) {
      for (let i = 0; i < 7; i++) {		  
		  if((rangeCurrent - 3) <= totalPages)
		  {
			range.push(rangeCurrent - 3);
		  }
		  rangeCurrent = rangeCurrent + 1;      
      }
    } 
	else 
	{
		var startFrom0 = 0;
		for (let i = 0; i < 7; i++) {		 
		if(rangeCurrent <=4)
		{
			startFrom0 += 1;
			range.push(startFrom0);
		}
		else
		{
			range.push((rangeCurrent++) - 3);
		}
      }
    }

    return range;
  }

  return (
    <div className="pagination">
      { totalPages <= 1 ? '' : <ul className="controls_contain">
        <li className={`left_button ${currentPage === 1 ? 'hidden' : ''}`}>
          <button onClick={prevClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="m12 20 1.178-1.178-4.651-4.67h10.14v-1.637H8.527l4.65-4.67L12 6.666l-6.667 6.666z" fill="currentColor" fillRule="evenodd"/>
            </svg>
          </button>
        </li>
        { pageRange(currentPage, totalPages).map((item, i) => {
          return (
            <li key={i}>
              <button 
                className={currentPage === item ? 'selected' : ''} 
                value={item}
                onClick={()=>{pageClick(item)}}>
                  {item}
              </button>
            </li>
          )})
        }
        <li className={`right_button ${currentPage === totalPages ? 'hidden' : ''}`}>
          <button onClick={nextClick}>
            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
              <path d="m7 14-1.178-1.178 4.651-4.67H.333V6.515h10.14l-4.65-4.67L7 .666l6.667 6.666z" fill="currentColor" fillRule="evenodd"/>
            </svg>
          </button>
        </li>
      </ul>}
      <span className="results">Results {numberOfResults} of {total}</span>
    </div>
  );
};